import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=2263c0f4&"
import script from "./login-form.vue?vue&type=script&lang=js&"
export * from "./login-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "login-form.vue"
export default component.exports